import React, { Component, createElement, Fragment, useRef } from "react";
import ReactDOM from "react-dom";
import OrganizationMap from "./OrganizationMap";
import OrganizationCard from "./OrganizationCard";
import ArchiveViewControl from "./ArchiveViewControl";
import ArchiveSearchBox from "./ArchiveSearchBox";
import ArchiveRadioGroupFilter from "./ArchiveRadioGroupFilter";
import ArchiveCheckboxGroupFilter, {
    CheckboxOption
} from "./ArchiveCheckboxGroupFilter";
import ArchiveResultCount from "./ArchiveResultCount";
import BaseGrid from "./BaseGrid";
import Loader from "./Loader";
import NoResults from "./NoResults";
import "whatwg-fetch";
import ReactPaginate from "react-paginate";

const abortableFetch = "signal" in new Request("") ? window.fetch : fetch;
let fetchController;

const debounce = (fn, delay) => {
    let timer = null;
    return function(...args) {
        const context = this;
        timer && clearTimeout(timer);
        timer = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};

const FILTERDEFAULTS = {
    filter_search_query: "",
    filter_provides_care_at_home: "2",
    filter_organization_cities: [],
    filter_contracted_care: [],
    filter_organization_types: []
};

class OrganizationArchive extends Component {
    constructor(props) {
        const FILTER_OPTIONS = {
            cities: window.pp_social_map_vars.cities || [],
            contracted_care_terms:
                window.pp_social_map_vars.contractedCare || [],
            organizationTypes: window.pp_social_map_vars.organizationType || [],
            add_organization_page_id:
                window.pp_social_map_vars.add_organization_page_id || null
        };

        super(props);

        this.listRef = React.createRef();

        this.state = {
            view: "list",
            organizations: [],
            cities: FILTER_OPTIONS.cities,
            contracted_care_terms: FILTER_OPTIONS.contracted_care_terms,
            organizationTypes: FILTER_OPTIONS.organizationTypes,
            add_organization_page_id: FILTER_OPTIONS.add_organization_page_id,
            sort: "asc",
            total: 0,
            currentPage: 1,
            totalPages: 0,
            loading: false,
            showScrollToTopButton: false,
            filter_search_query: FILTERDEFAULTS.filter_search_query,
            filter_provides_care_at_home:
                FILTERDEFAULTS.filter_provides_care_at_home,
            filter_organization_cities:
                FILTERDEFAULTS.filter_organization_cities,
            filter_contracted_care: FILTERDEFAULTS.filter_contracted_care,
            filter_organization_types: FILTERDEFAULTS.filter_organization_types,
            post_per_page: 10,
            showFilters: false,
            tooltipText: "U Kunt niet zoeken op een plaatsnaam",
        };

        this.applyFilterState();
    }

    componentDidMount() {
        this.retrieveOrganizations();

        window.addEventListener(
            "scroll",
            debounce(this.toggleScrollToTopButton.bind(this), 20)
        );
    }

    componentWillUnmount() {
        window.removeEventListener(
            "scroll",
            debounce(this.toggleScrollToTopButton.bind(this), 20)
        );
    }

    saveFilterState() {
        const filters = {
            filter_search_query: this.state.filter_search_query,
            filter_provides_care_at_home: this.state
                .filter_provides_care_at_home,
            filter_organization_cities: this.state.filter_organization_cities,
            filter_contracted_care: this.state.filter_contracted_care,
            filter_organization_types: this.state.filter_organization_types
        };

        localStorage.setItem("social-map-filters", JSON.stringify(filters));
    }

    applyFilterState() {
        const filtersRaw = localStorage.getItem("social-map-filters");

        if (!filtersRaw) {
            return;
        }

        const filters = JSON.parse(filtersRaw);

        this.state.filter_search_query = filters.filter_search_query
            ? filters.filter_search_query
            : FILTERDEFAULTS.filter_search_query;
        this.state.filter_provides_care_at_home = filters.filter_provides_care_at_home
            ? filters.filter_provides_care_at_home
            : FILTERDEFAULTS.filter_provides_care_at_home;
        this.state.filter_organization_cities = filters.filter_organization_cities
            ? filters.filter_organization_cities
            : FILTERDEFAULTS.filter_organization_cities;
        this.state.filter_contracted_care = filters.filter_contracted_care
            ? filters.filter_contracted_care
            : FILTERDEFAULTS.filter_contracted_care;
        this.state.filter_organization_types = filters.filter_organization_types
            ? filters.filter_organization_types
            : FILTERDEFAULTS.filter_organization_types;
    }

    retrieveOrganizations() {
        this.saveFilterState();

        if (this.state.loading) {
            fetchController.abort();
        }

        fetchController = new AbortController();

        this.setState({ loading: true });

        let pageSize = 10;

        if (this.state.view === "map") {
            pageSize = 5000;
        }

        const JSON_API_URL = `/wp-json/wp/v2/pp_gids_organization`;

        const params = {
            orderby: "title",
            order: this.state.sort,
            per_page: pageSize,
            page: this.state.currentPage
        };

        if (this.state.filter_search_query !== "") {
            params.search = this.state.filter_search_query;
        }

        if (this.state.filter_organization_cities.length !== 0) {
            params.pp_gids_organization_city = this.state.filter_organization_cities;
        }

        if (this.state.filter_contracted_care.length !== 0) {
            params.pp_gids_org_contracted_care = this.state.filter_contracted_care;
        }

        if (this.state.filter_organization_types.length !== 0) {
            params.pp_gids_organization_type = this.state.filter_organization_types;
        }

        if (
            this.state.filter_provides_care_at_home !== null &&
            this.state.filter_provides_care_at_home != 2
        ) {
            params.filter = {
                meta_key: "pp_provides_care_at_home",
                meta_value: this.state.filter_provides_care_at_home
            };
        }

        const serialize = obj => {
            return Object.entries(obj)
                .filter(([, value]) => value)
                .map(([key, value]) => {
                    if (typeof value === "object") {
                        return Object.entries(value).map(
                            ([subkey, value]) =>
                                `${key}[${subkey}]=${encodeURIComponent(value)}`
                        );
                    } else {
                        return `${key}=${encodeURIComponent(value)}`;
                    }
                })
                .join("&");
        };

        let url = `${JSON_API_URL}?${serialize(params)}`;

        abortableFetch(url, {
            signal: fetchController.signal
        })
            .then(response => {
                this.setState({
                    total: parseInt(response.headers.get("x-wp-total"), 10),
                    totalPages: parseInt(
                        response.headers.get("x-wp-totalpages"),
                        10
                    )
                });

                return response.json();
            })
            .then(data => {
                this.setState({ organizations: data, loading: false });
            });
    }

    handleChangeView(view) {
        this.setState(
            {
                view: view,
                currentPage: 1
            },
            () => this.retrieveOrganizations()
        );
    }

    handleChangeSort(sort) {
        this.setState(
            {
                sort: sort,
                currentPage: 1
            },
            () => this.retrieveOrganizations()
        );
    }

    handleChangePage(pageObject) {
        this.setState(
            {
                currentPage: pageObject.selected + 1
            },
            () => this.retrieveOrganizations()
        );
    }

    renderMap() {
        return <OrganizationMap organizations={this.state.organizations} />;
    }

    parseWPTermsToFilterOption(terms) {
        return terms.map(term => {
            let option = new CheckboxOption();
            option.name = term.name;
            option.value = term.term_id;

            return option;
        });
    }

    parseCareProvidedAtHomeFilterOptions() {
        return [
            new CheckboxOption("2", "Alle", true),
            new CheckboxOption("1", "Ja"),
            new CheckboxOption("0", "Nee")
        ];
    }

    handleChangedSearchQuery(e) {
        e.preventDefault();
        this.setState(
            {
                filter_search_query: e.target.value
            }
            // () => this.retrieveOrganizations()
        );
    }

    handleChangedProvidesCareAtHome(e) {
        e.preventDefault();

        this.setState({ filter_provides_care_at_home: e.target.value });
    }

    handleChangedCheckboxGroupFilter(e, key) {
        const options = this.state[key];
        const value = e.target.value;
        const valueIndex = options.findIndex(
            option => option === parseInt(value)
        );

        if (valueIndex != -1 && !e.target.checked) {
            options.splice(valueIndex, 1);
        } else {
            options.push(parseInt(value));
        }

        this.setState({ [key]: options });
    }

    scrollToTop() {
        this.listRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest"
        });
    }

    toggleScrollToTopButton() {
        const showButton = window.scrollY > 550;

        if (showButton) {
            this.setState({ showScrollToTopButton: true });
        } else {
            this.setState({ showScrollToTopButton: false });
        }
    }

    renderGrid() {
        return (
            <Fragment>
                <div className="section section--list" ref={this.listRef}>
                    <header className="section__header">
                        <ArchiveResultCount resultCount={this.state.total} />
                        <ArchiveViewControl
                            activeView={this.state.view}
                            onChangeView={view => this.handleChangeView(view)}
                            sort={this.state.sort}
                            onChangeSort={sort => this.handleChangeSort(sort)}
                        />
                    </header>
                    <BaseGrid loading={this.state.loading}>
                        {this.state.organizations.length > 0 ? (
                            this.state.organizations.map(organization => {
                                return (
                                    <OrganizationCard
                                        organization={organization}
                                        key={organization.id}
                                    />
                                );
                            })
                        ) : this.state.loading ? (
                            <Loader loadingText="Organisaties worden geladen..." />
                        ) : (
                            <NoResults />
                        )}
                    </BaseGrid>

                    {this.state.showScrollToTopButton ? (
                        <div className="organization__buttons back-to-top">
                            <button
                                className="button small button--secondary button--sticky button--hide-if-not-sticky"
                                onClick={e => this.scrollToTop()}
                            >
                                Terug naar boven
                            </button>
                        </div>
                    ) : null}
                    {this.state.organizations.length > 0 ? (
                        <nav className="pagination" aria-label="Meer organisaties" aria-roledescription="paginering">
                            <ReactPaginate
                                containerClassName="pagination__items"
                                pageClassName="pagination__item"
                                breakClassName="pagination__item"
                                activeClassName="pagination__item--active"
                                nextClassName="pagination__item--next"
                                previousClassName="pagination__item--prev"
                                pageCount={this.state.totalPages}
                                pageRangeDisplayed={3}
                                marginPagesDisplayed={2}
                                previousLabel="Vorige"
                                nextLabel="Volgende"
                                breakLabel={
                                    <span
                                        role="button"
                                        aria-label="Navigeer 3 stappen vooruit"
                                    >
                                        ...
                                    </span>
                                }
                                onPageChange={this.handleChangePage.bind(this)}
                            />
                        </nav>
                    ) : null}
                </div>
            </Fragment>
        );
    }

    getWrapperClass() {
        const loadingCLass = this.state.loading ? "loading" : "";

        return `social-map social-map__wrapper ${loadingCLass} ${this.state.view}-view`;
    }

    getContentWrapperClass() {
        return `social-map__content social-map__content--${this.state.view}-view`;
    }

    resetFilters() {
        this.setState(
            oldState => {
                return {
                    filter_search_query: "",
                    filter_provides_care_at_home: "2",
                    filter_organization_cities: [],
                    filter_contracted_care: []
                };
            },
            () => this.retrieveOrganizations()
        );
        this.forceUpdate();

        localStorage.removeItem("social-map-filters");
    }

    toggleFilters() {
        this.setState(prevState => ({
            showFilters: !prevState.showFilters
        }));
    }

    renderFilterSectionClasses() {
        return this.state.showFilters
            ? "section section--filters"
            : "section section--filters closed";
    }

    render() {
        return (
            <div className={this.getWrapperClass()}>
                <div className={this.getContentWrapperClass()}>
                    <ArchiveViewControl
                        activeView={this.state.view}
                        onChangeView={view => this.handleChangeView(view)}
                        sort={this.state.sort}
                        onChangeSort={sort => this.handleChangeSort(sort)}
                    />
                    <div className={this.renderFilterSectionClasses()}>
                        <div
                            className="show-filters-button"
                            onClick={e => this.toggleFilters()}
                        >
                            <div className="show-filters-button__label">
                                Filters
                            </div>
                            <div className="show-filters-button__icon"></div>
                        </div>
                        <div className="content">
                            <header>
                                <h2 className="social-map__title">Filters</h2>
                                <button
                                    className="social-map__reset"
                                    onClick={e => this.resetFilters(e)}
                                >
                                    Reset filter
                                </button>
                            </header>

                            <ArchiveSearchBox
                                title="Zoekterm"
                                tooltipText={this.state.tooltipText}
                                onChanged={e => {
                                    this.handleChangedSearchQuery(e);
                                }}
                                onEnter={() => {
                                    this.retrieveOrganizations();
                                }}
                                searchQuery={this.state.filter_search_query}
                            />
                            <ArchiveCheckboxGroupFilter
                                key="cities"
                                title="Plaats"
                                options={this.parseWPTermsToFilterOption(
                                    this.state.cities
                                )}
                                value={this.state.filter_organization_cities}
                                onChanged={e =>
                                    this.handleChangedCheckboxGroupFilter(
                                        e,
                                        "filter_organization_cities"
                                    )
                                }
                            />
                            <ArchiveCheckboxGroupFilter
                                key="contracted-care"
                                title="Gecontracteerde zorg"
                                options={this.parseWPTermsToFilterOption(
                                    this.state.contracted_care_terms
                                )}
                                value={this.state.filter_contracted_care}
                                onChanged={e =>
                                    this.handleChangedCheckboxGroupFilter(
                                        e,
                                        "filter_contracted_care"
                                    )
                                }
                            />
                            {/* <ArchiveCheckboxGroupFilter
                                key="organization-types"
                                title="Organisatie soort"
                                options={this.parseWPTermsToFilterOption(
                                    this.state.organizationTypes
                                )}
                                value={this.state.filter_organization_types}
                                onChanged={e =>
                                    this.handleChangedCheckboxGroupFilter(
                                        e,
                                        "filter_organization_types"
                                    )
                                }
                            /> */}
                            {/* <ArchiveRadioGroupFilter
                                key="provides_care_at_home"
                                id="provides_care_at_home"
                                title="Zorg aan huis"
                                options={this.parseCareProvidedAtHomeFilterOptions()}
                                onChanged={e =>
                                    this.handleChangedProvidesCareAtHome(e)
                                }
                                value={this.state.filter_provides_care_at_home}
                            /> */}
                            <div className="buttons">
                                <button
                                    className="button button--block rewrite-css-vars button--primary"
                                    type="submit"
                                    onClick={e => this.retrieveOrganizations()}
                                >
                                    Zoeken
                                </button>
                            </div>

                            <hr />
                            {this.state.add_organization_page_id ? (
                                <div className="section__add-organization-link">
                                    <a
                                        href={
                                            this.state.add_organization_page_id
                                        }
                                    >
                                        Een organisatie laten wijzigen
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    {this.state.view === "list"
                        ? this.renderGrid()
                        : this.renderMap()}
                </div>
            </div>
        );
    }
}

document.addEventListener("DOMContentLoaded", () => {
    let el = document.querySelector(".social-map-root");
    if (el === null) {
        return;
    }

    ReactDOM.render(createElement(OrganizationArchive, el.dataset), el);
});
